export const configuratorUserEntryI18NDe = {
    you: "Sie",
};
